'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Configure2FAFreemiumRequest(seeds, invites) {
  this.q8 = null;
  this.Kx = null;
  this.q8 = seeds;
  this.Kx = invites;
}
export { $c_Lpresto_types$Configure2FAFreemiumRequest as $c_Lpresto_types$Configure2FAFreemiumRequest };
$p = $c_Lpresto_types$Configure2FAFreemiumRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Configure2FAFreemiumRequest;
/** @constructor */
function $h_Lpresto_types$Configure2FAFreemiumRequest() {
}
export { $h_Lpresto_types$Configure2FAFreemiumRequest as $h_Lpresto_types$Configure2FAFreemiumRequest };
$h_Lpresto_types$Configure2FAFreemiumRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Configure2FAFreemiumRequest)) {
    var x = this.q8;
    var x$2 = x$0.q8;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.Kx;
      var x$4 = x$0.Kx;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "Configure2FAFreemiumRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.q8;
  }
  if ((n === 1)) {
    return this.Kx;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$Configure2FAFreemiumRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jq)));
}
export { $isArrayOf_Lpresto_types$Configure2FAFreemiumRequest as $isArrayOf_Lpresto_types$Configure2FAFreemiumRequest };
var $d_Lpresto_types$Configure2FAFreemiumRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Configure2FAFreemiumRequest, "presto.types$Configure2FAFreemiumRequest", ({
  jq: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Configure2FAFreemiumRequest as $d_Lpresto_types$Configure2FAFreemiumRequest };
//# sourceMappingURL=presto.types$-Configure2-F-A-Freemium-Request.js.map
